var map = {
	"./quoted_1.png": 58614,
	"./quoted_10.png": 34660,
	"./quoted_2.png": 90381,
	"./quoted_3.png": 27140,
	"./quoted_4.png": 81947,
	"./quoted_5.png": 60402,
	"./quoted_6.png": 8585,
	"./quoted_7.png": 84384,
	"./quoted_8.png": 44967,
	"./quoted_9.png": 69182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58994;